import { type ExceptionLog, ExceptionLogSchema } from '../data/exception-log';
import { compare } from '../helpers/column-sort';
import { createMultipleHandler } from '../helpers/fetch-wrapper';
import { storesBaseUrl as baseUrl, StoreScopedService } from './base';

export class ExceptionLogService extends StoreScopedService {
  getExceptionLogsByStore(storeId: string): Promise<ExceptionLog[]> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/exception-logs`)
      .then(createMultipleHandler(ExceptionLogSchema))
      .then((logs: ExceptionLog[]) => {
        return logs.sort((a, b) => compare(b.timestamp, a.timestamp));
      });
  }
}
